function init() {
	var newsletterAcceptChecked = false;
	
	$(".accept-privacy-checkbox").bind("click",function() {
		var ischecked= $(this).is(':checked');
		var button = $($(this).attr("button"));

		if(ischecked){
			newsletterAcceptChecked = true;
			
			if(newsletterEmailValid){
				button.prop('disabled', false);
			}else{
				button.prop('disabled', true);
			}
		}else{
			newsletterAcceptChecked = false;
			button.prop('disabled', true);
		}
	}); 	
	
	var newsletterEmailValid = false;
	
	$("#newsletter-email").unbind("keyup");
	$("#newsletter-email").keyup(function(){
		var button = $($(this).attr("button"));
		var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		
		if(regex.test(String($(this).val()).toLowerCase())){
			newsletterEmailValid = true;
			
			if(newsletterAcceptChecked){
				button.prop('disabled', false);
			}else{
				button.prop('disabled', true);
			}
		}else{
			newsletterEmailValid = false;
			button.prop('disabled', true);
		}
	});
	
	$("#newsletter-submit-btn").unbind("click");
	$("#newsletter-submit-btn").bind("click",function(e) {
		var form =  $(this).closest("form");
		var button = $(this);
		button.prop('disabled', true);
		
		$("#newsletter-key").val("q69n8Ag5tvQ5hviFeVynQ7XjXXkOj0dJ");
		
		$.ajax({
		   type: "POST",
		   url: form.attr("action"),
		   data: form.serialize(), 
		   success: function(data)
		   {
			   button.prop('disabled', false);

			   $(".newsletter-subscription-received").fadeIn(function(){
				   setTimeout(function(){
					   $(".newsletter-subscription-received").fadeOut(function(){
						   button.prop('disabled', true);
						   $("#newsletter-email").val("");
						   $(".accept-privacy-checkbox").prop( "checked", false );
					   }); 
				   }, 3000);
			   });
		   },
		   error: function(){$(this).prop('disabled', false);}
		 });
		
		e.preventDefault();
	});
}

module.exports = {
	init : init
}